export default "__VITE_ASSET__r0z$bqrH__"